/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Pipelines_Stage_NInputs */

const cs_pipelines_stage_n = /** @type {(inputs: Pipelines_Stage_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fáze ${i?.n}`)
};

const en_pipelines_stage_n = /** @type {(inputs: Pipelines_Stage_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stage ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Stage {n}" |
*
* @param {Pipelines_Stage_NInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_stage_n = /** @type {((inputs: Pipelines_Stage_NInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Stage_NInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_stage_n(inputs)
	return cs_pipelines_stage_n(inputs)
});